function Intro() {
  return (
    <div className="alert alert-success">
      <h1 style={{ fontSize: '24px', marginBottom: '10px' }}>
        <b>Calculatrices en ligne gratuites en francais</b>
      </h1>
      <p>
        Do Calculate regroupe des centaines de calculatrices utiles pour le quotidien, les etudes et le travail. Vous y trouverez des outils fiables pour les maths, la sante, la finance, la physique, la chimie, la nutrition, les dates et les conversions d'unites. Chaque calculatrice est pensee pour aller droit au but: vous saisissez vos donnees, vous obtenez un resultat clair, puis vous passez a l'etape suivante sans perdre de temps.
      </p>
      <hr />
    </div>
  );
}

export default Intro;
